import { render, staticRenderFns } from "./apinvfrmvoid.vue?vue&type=template&id=7188f97e"
import script from "./apinvfrmvoid.vue?vue&type=script&lang=js"
export * from "./apinvfrmvoid.vue?vue&type=script&lang=js"
import style0 from "./apinvfrmvoid.vue?vue&type=style&index=0&id=7188f97e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports